import { lenis } from "./lenis";

export default (ref, { signal } = { signal: null }) => {
  if (!ref.parallax) return;

  let running = true;

  function getValues(items) {
    return items.map((element) => {
      element.style.removeProperty("transform");

      const { top, height } = element.getBoundingClientRect();
      const inTop = element.dataset.isInTop !== undefined;
      const center = inTop
        ? 0
        : top + height / 2 + lenis.animatedScroll - window.innerHeight / 2;

      return {
        speed: parseFloat(element.dataset.speed || 10),
        element,
        center,
      };
    });
  }

  let items = getValues(ref.parallax);

  window.addEventListener("resize", () => (items = getValues(ref.parallax)), {
    signal,
  });

  function tick() {
    if (!running) return;

    requestAnimationFrame(tick);

    items.forEach((item) => {
      const pos = (item.center - lenis.animatedScroll) / window.innerHeight;

      if (pos < -1 || pos > 1) return;

      item.element.style.transform = `translateY(${pos * item.speed}vmin)`;
    });
  }

  tick();

  return () => {
    running = false;
  };
};
